export default {
  common: {
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    loading: 'Загрузка...',
    success: 'Операция успешна',
    error: 'Операция не удалась',
    networkError: 'Ошибка сети'
  },
  nav: {
    home: 'Главная',
    card: 'Карта',
    contacts: 'Контакты',
    chat: 'Чат',
    profile: 'Профиль'
  },
  profile: {
    title: 'Профиль',
    personalInfo: 'Личная информация',
    editProfile: 'Редактировать профиль',
    myCards: 'Мои карты',
    myContacts: 'Мои контакты',
    settings: 'Настройки',
    logout: 'Выйти из системы',
    totalVisitors: 'Всего посетителей',
    friendCount: 'Количество друзей',
    todayVisitors: 'Сегодняшние посетители',
    todayIncrement: 'Сегодняшний прирост'
  },
  settings: {
    accountSecurity: 'Безопасность аккаунта',
    notificationSettings: 'Настройки уведомлений',
    languageSettings: 'Настройки языка',
    logout: 'Выйти из системы',
    accountSecurityDesc: 'Смена пароля, привязка телефона и т.д.',
    notificationSettingsDesc: 'Управление предпочтениями уведомлений',
    languageSettingsDesc: 'Выбор языка приложения',
    logoutDesc: 'Безопасный выход из текущего аккаунта'
  },
  language: {
    title: 'Настройки языка',
    selectLanguage: 'Выберите язык',
    zhCN: 'Китайский (упрощенный)',
    enUS: 'Английский',
    jaJP: 'Японский',
    koKR: 'Корейский',
    ruRU: 'Русский'
  },
  contact: {
    sameLevel: 'Контакты одного уровня',
    higherLevel: 'Контакты более высокого уровня',
    goldMember: 'Золотой член',
    platinumMember: 'Платиновый член',
    diamondMember: 'Бриллиантный член',
    unlock: 'Разблокировать',
    contact: 'Связаться',
    unlockContact: 'Разблокировать контакт',
    upgradeForContacts: 'Чтобы разблокировать больше контактов, обновите членство'
  },
  storage: {
    basicPlan: 'Базовый план',
    professionalPlan: 'Профессиональный план',
    enterprisePlan: 'Корпоративный план',
    month: 'Месяц',
    features: {
      basic: ['50 ГБ хранилища', 'Базовая безопасность', 'Обмен файлами'],
      professional: ['200 ГБ хранилища', 'Расширенное шифрование безопасности', 'Коллективная работа', 'Приоритетная служба поддержки'],
      enterprise: ['1 ТБ хранилища', 'Корпоративный уровень безопасности', 'Безограниченное сотрудничество', 'Персональная служба поддержки']
    },
    buyStorage: 'Купить хранилище',
    buyPlan: 'Купить план',
    uploadFile: 'Загрузить файл',
    viewFiles: 'Просмотреть файлы',
    downloadAll: 'Массовый загрузка',
    documents: 'Документы',
    images: 'Изображения',
    videos: 'Видео',
    others: 'Другое'
  },
  menu: {
    myCards: 'Мои карты',
    myCardsDesc: 'Управление моими цифровыми картами',
    memberCenter: 'Центр членов',
    memberCenterDesc: 'Обновите членство для получения дополнительных льгот',
    myFavorites: 'Мои избранное',
    myFavoritesDesc: 'Просмотр сохраненного контента',
    myRelations: 'Мои отношения',
    myRelationsDesc: 'Управление социальными отношениями',
    chat: 'Чат и общение',
    chatDesc: 'Общайтесь и общайтесь с друзьями',
    contacts: 'Контакты',
    contactsDesc: 'Управление контактами',
    privacy: 'Настройки конфиденциальности',
    privacyDesc: 'Управление правами конфиденциальности'
  }
}
